import { JsonSerializationProps, useGenericJsonSerializer } from '#record/jsonserializer'
import { PriorTrxAuthPatch } from '#trxauth.prior/model'




// types the json row produced by a parse with the keys specified in config.
// types the json row produced by a parse with the keys specified in config.
export type PriorTrxAuthzJsonSerialization = Partial<{

    uvi: string
    from: string
    to: string
    revoke:string
    number: string
    entity: string
    
  }>


export const usePriorTrxAuthzJsonSerializer = () => {

    //const formatString = useAppSettings().resolveFormat()

    const serializer = (props: JsonSerializationProps<PriorTrxAuthPatch>): PriorTrxAuthzJsonSerialization => {
       
        // const { patch } = props

        // const { } = patch.trxauth.authzs

        // const fromString = mode === 'full' ? new Date().toISOString() : format(new Date(from),formatString)
        // const toString = mode === 'full' ? new Date().toISOString() : format(new Date(to),formatString)

        return { }
    }

    return useGenericJsonSerializer(serializer)
     
}